import VehicleCategory from '@/types/vehicle-category';

export const MB_RENT_DEFAULT_CATEGORY = VehicleCategory.M;

export const KNOWN_VEHICLE_CATEGORIES = Object.values(VehicleCategory);
